<template>
  <div class="leave-board">
    <div class="header">
      <i class="el-icon-back" @click="goBack"></i>
      <span>我要留言</span>
      <img src="@/assets/person/leaveBoard/dp-gr-ly1.png" alt />
      <span @click="goRecord">我的留言记录</span>
    </div>
    <div class="second-line">
      <img src="@/assets/person/leaveBoard/dp-gr-ly2.png" alt />
    </div>
    <div class="third-line">
      <el-input
        type="textarea"
        placeholder="请输入内容"
        v-model="textarea"
        maxlength="100"
        :autosize="{ minRows: 6, maxRows: 6 }"
        show-word-limit
        style="font-size:.34rem"
      ></el-input>
    </div>

    <div class="four-line">
      <div class="name">
        <p>姓名:</p>
        <p>{{name}}</p>
      </div>
      <div class="name">
        <p>电话:</p>
        <p>{{phone}}</p>
      </div>
      <div class="name">
        <p>留言时间:</p>
        <p>{{times}}</p>
      </div>
    </div>

    <div class="submit">
      <button @click="submit">确认提交</button>
    </div>

    <div class="motai" v-if="motai">
      <div class="show">
        <img src="@/assets/person/leaveBoard/dp-gr-ly4.png" alt />
        <p>提交留言信息成功</p>
        <p>管理员将于2个工作日内审核并回复，敬请期待！</p>
        <button @click="mot">我知道了</button>
      </div>
    </div>
  </div>
</template>




<script>
export default {
  data() {
    return {
      textarea: "",
      times: this.getime(),
      phone: sessionStorage.getItem("mobileid"),
      name: sessionStorage.getItem("name"),
      motai: false
    };
  },
  created: function() {},
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    mot() {
      this.motai = false;
    },
    submit() {
      if (this.textarea != "") {
        this.axios
          .post("/api/Personal/AddMessage", {
            name: this.name,
            phone: this.phone,
            memo: this.textarea,
            headline: sessionStorage.getItem("token"),
            createtime: this.times
          })
          .then(e => {
            alert(e.data.msg);
          })
          .catch(err => {
            console.log(err);
          });
        this.motai = true;
      }
    },
    getime() {
      let date = new Date();
      return (
        date.getFullYear() +
        "." +
        (date.getMonth() + 1) +
        "." +
        date.getDay() +
        " " +
        date.getHours() +
        ":" +
        date.getMinutes()
      );
    },
    goRecord() {
      this.$router.push({
        path: "/person/leaverecord",
        query: { title: "留言记录" }
      });
    }
  }
};
</script>



<style lang='scss' scoped>
.leave-board {
  .motai {
    .show {
      button {
        border-radius: 0.34rem;
        background-image: linear-gradient(1deg, #f9b94d 0%, #fdcb76 100%),
          linear-gradient(#eb7d14, #eb7d14);
        padding: 0.2rem 0.4rem;
        border: 0;
        font-size: 0.3rem;
        color: #fff;
        position: absolute;
        bottom: 1rem;
        left: 33%;
      }
      p {
        &:nth-child(3) {
          position: absolute;
          top: 5.2rem;
          width: 80%;
          left: 10%;
        }
        &:nth-child(2) {
          position: absolute;
          top: 4.6rem;
          width: 100%;
          font-weight: bold;
        }

        text-align: center;
      }

      img {
        width: 100%;
      }

      width: 80%;
      margin: 18vh auto;
      position: relative;
    }
    width: 100%;
    position: fixed;
    top: 0;
    height: 100vh;
    background: rgba($color: #000000, $alpha: 0.2);
  }
  .submit {
    button {
      width: 3.8rem;
      height: 0.8rem;
      background-image: linear-gradient(1deg, #f9b94d 0%, #fdcb76 100%),
        linear-gradient(-70deg, #fb3f3f 0%, #fe5f5f 100%);
      background-blend-mode: normal, normal;
      box-shadow: 0.01rem 0.1rem 0.1rem 0px rgba(249, 186, 79, 0.1);
      border-radius: 0.08rem;
      border: 0;
      color: #fff;
      font-size: 0.3rem;
    }
    text-align: center;
    padding: 0.8rem 0;
  }
  .four-line {
    div {
      display: flex;
      justify-items: center;
      line-height: 3;
      color: #999999;
      border-bottom: 0.01rem solid #e6e6e6;
    }
  }
  .four-line,
  .third-line {
    textarea {
      font-size: 0.34rem;
    }
    padding: 0 0.2rem;
  }
  .second-line {
    img {
      padding-left: 0.2rem;
      width: 80%;
    }

    padding-top: 1.5rem;
  }
  .header {
    span {
      &:last-child {
        margin-right: 0.2rem;
        color: #f6ae33;
        font-size: 0.3rem;
      }
    }
    img {
      width: 0.3rem;
      height: 0.25rem;
      margin-left: auto;
    }
    i {
      margin: 0 0.2rem;
    }
    display: flex;
    align-items: center;
    line-height: 2.5;
    position: fixed;
    width: 100%;
    z-index: 9;
    background: #fff;
    font-size: 0.36rem;
    box-shadow: 0px 0.06rem 0.06rem 0px rgba(0, 0, 0, 0.06);
  }
  background: #fff;
  font-size: 0.3rem;
  height: 100vh;
}
</style>